<template>
  <div class="my-order">
    <div>我的订单</div>
    <div class="mt30">
      <el-tabs v-model="tab">
        <el-tab-pane label="所有订单" name=""></el-tab-pane>
        <el-tab-pane label="待确认" name="1"></el-tab-pane>
        <el-tab-pane label="待发货" name="4"></el-tab-pane>
        <el-tab-pane label="待收货" name="5"></el-tab-pane>
        <el-tab-pane label="已完成" name="6"></el-tab-pane>
        <el-tab-pane label="售后" name="9999"></el-tab-pane>
      </el-tabs>

      <!-- 搜索 -->

      <div>
        <el-input style="width: 336px" placeholder="请输入订单号搜索" v-model="order_no" size="mini"></el-input>

        <el-button class="ml20" type="primary" size="mini" @click="getOrderList">搜索</el-button>
      </div>
    </div>

    <!--订单列表-->
    <!--表头-->

    <div class="fr ac fz12 mt30">
      <div class="center order-list-item">产品信息</div>
      <div class="center order-list-item">产品规格</div>
      <div class="center order-list-item">设备信息</div>
      <!-- <div class="center order-list-item">配套工艺</div> -->
      <div class="center order-list-item">产品价格</div>
      <div class="center order-list-item">数量</div>
      <div class="center order-list-item">小计</div>
      <div class="center fg">操作</div>
    </div>

    <el-divider/>

    <!--列表-->
    <!-- 普通订单列表 -->
    <div class="order-list fz12" v-if="tab != '9999'">
      <div class="order-item mt20" v-for="(item,index) in order_list" :key="index">
        <!-- 上-->
        <div class="top">
          <span>{{ item.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ item.order_no }}</span>
          <span class="ml40 blue" v-if="tab != '9999'" v-html="order_state_decide(item)"></span>
          <span class="ml40 blue" v-else>{{ item.is_reply == "1" ? "已回复" : "未回复" }}</span>
        </div>
        <!-- 中-->

        <div class="fr middle">
          <!-- 商品信息 -->
          <div class="order">
            <div class="fr jc ac order-left" v-for="(goods,i) in item.orderGoodsBeans" :key="i">
              <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                <el-image class="goods_img fs mr10" :src="goods.goods_img" alt/>
                <div>
                  <p class>{{ goods.goods_name }} {{ goods.goods_standard_name }}</p>
                </div>
              </div>
              <div class="center order-list-item">{{ specNameInit(goods) }}</div>
              <div class="center order-list-item">{{ goods.device_id ? goods.device_id : '-' }}</div>
              <div class="center order-list-item">￥{{ goods.specification_price }}</div>
              <div class="center order-list-item">{{ goods.goods_num }}</div>
              <div class="center order-list-item red">￥{{ goods.goods_actual_price }}</div>
            </div>
          </div>
          <!-- 操作 -->
          <div class=" operating">
            <template v-if="tab != '999'">
              <!-- 待审核订单,销售未审核时的取消订单 -->
              <template v-if="item.company_check_state == '1' && item.platform_sale_check_state == '0'">
                <el-link :underline="false" @click="cancelOrder(item.order_id)">取消订单</el-link>
              </template>
              <!-- 待收货订单 -->
              <template v-if="['2','3'].includes(item.send_state)">
                <el-link :underline="false"
                         :href="`/logistics?id=${item.order_id}&compnay_id=${$route.query.company_id}`">
                  查看物流
                </el-link>

              </template>
              <!-- 待评价订单 -->
              <template v-if="item.contract_check_state === '1'">
                <el-link :underline="false" @click="goFeed(item)">质量反馈</el-link>
                <el-link :underline="false" @click="repurchaseOrder(item)">复购</el-link>
              </template>
              <template v-if="item.pay_state === '3' && item.send_state === '4'">
                <el-link :underline="false" @click="getAssessmentGoods(item)">立即评价</el-link>
                <el-link v-if="item.is_service != '1'" :underline="false" :href="`/releaseservice?id=${item.order_id}`">
                  申请服务
                </el-link>
              </template>

              <!-- 待发货订单 -->
              <el-link v-if="tab !== '9999'" :underline="false" :href="`/orderdetail?id=${item.order_id}`">订单详情
              </el-link>
            </template>

            <!-- 质量反馈 -->
            <template v-if="tab === '9999'">

              <el-link :underline="false" :href="`/feedbackdetail?id=${item.order_id}`">订单详情</el-link>
            </template>
          </div>
        </div>

        <!-- 下-->
        <div class="p20 fz14 bottom black" style="text-align: right">
          <div>
            <span>订单金额</span>
            <span class="blue">￥{{ item.order_actual_price }}</span>
          </div>
          <div class="mt10">
            <span>已付款</span>
            <span>￥{{ item.pay_price }}</span>
          </div>
          <div class="mt10">
            <span>未付款</span>
            <span class="red">￥{{ sub(item.order_actual_price, item.pay_price) }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务订单列表 -->
    <div class="order-list fz12" v-if="tab === '9999'">
      <div class="order-item mt20" v-for="(item,index) in order_list" :key="index">
        <!-- 上-->
        <div class="top">
          <span>{{ item.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ item.order_no }}</span>
          <span class="ml40 blue">{{ item.is_reply == "1" ? "已回复" : "未回复" }}</span>
        </div>
        <!-- 中-->

        <div class="fr middle">
          <!-- 商品信息 -->
          <div class="order">
            <div class="fr jc ac order-left">
              <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                <el-image class="goods_img fs mr10" :src="item.orderGoodsBean.goods_img" alt/>
                <p class>{{ item.orderGoodsBean.goods_name }} {{ item.orderGoodsBean.goods_standard_name }}</p>
              </div>
              <div class="center order-list-item"> {{ specNameInit(item.orderGoodsBean) }}</div>
              <div
                  class="center order-list-item"
              >{{ item.orderGoodsBean.device_id ? item.orderGoodsBean.device_id : '-' }}
              </div>
              <div
                  class="center order-list-item"
              >{{ item.orderGoodsBean.specification_price }}
              </div>
              <div class="center order-list-item">{{ item.orderGoodsBean.goods_num }}</div>
              <div
                  class="center order-list-item red"
              >{{ item.orderGoodsBean.goods_actual_price }}
              </div>
            </div>
          </div>
          <!-- 操作 -->
          <div class=" operating">
            <!-- 质量反馈 -->
            <el-link :underline="false" :href="`/feedbackdetail?id=${item.order_id}`">订单详情</el-link>
          </div>
        </div>

        <!-- 下-->
        <div class="p20 fz14 bottom black" style="text-align: right">
          <div>
            <span>订单金额</span>
            <span class="blue">￥{{ item.order_actual_price }}</span>
          </div>
          <div class="mt10">
            <span>已付款</span>
            <span>￥{{ item.pay_price }}</span>
          </div>
          <div class="mt10">
            <span>未付款</span>
            <span class="red">￥{{ sub(item.order_actual_price, item.pay_price) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="fr jc ac mt30 mb30">
      <el-pagination
          background
          :hide-on-single-page="true"
          :current-page.sync="page"
          layout="prev, pager, next"
          :total="total"
      ></el-pagination>
    </div>
    <!-- 选择商品评价 -->
    <re-dialog :visible.sync="dialogVisible" width="900px">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">选择评价商品</p>
        <i class="el-icon-close fz14 cursor" @click="dialogVisible = false"></i>
      </div>
      <div class="order-list">
        <div class="order-item mt20">
          <!-- 上-->
          <div class="top">
            <span>{{ assessment_list.create_time }}</span>
            <span class="ml20 grey">订单编号：{{ assessment_list.order_no }}</span>
            <span class="ml40 blue" v-html="order_state_decide(assessment_list)"></span>
          </div>
          <!-- 中-->
          <div class="middle">
            <!-- 商品信息 -->
            <div v-for="(goods,i) in assessment_list.orderGoodsBeans" :key="i" class="fr">
              <div class="fs fr ac jc radio">
                <el-radio v-model="radio" :label="goods.order_goods_id">&nbsp;</el-radio>
              </div>
              <div class="order fr fs">
                <div class="fr jc ac order-left">
                  <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                    <el-image class="goods_img fs mr10" :src="goods.goods_img" alt/>
                    <p class>{{ goods.goods_name }} {{ goods.goods_standard_name }}</p>
                  </div>
                  <div class="center order-list-item"> {{ specNameInit(goods) }}</div>

                  <div class="center order-list-item">{{ goods.device_id ? goods.device_id : '-' }}</div>
                  <div class="center order-list-item">￥{{ goods.specification_price }}</div>
                  <div class="center order-list-item">{{ goods.goods_num }}</div>
                  <div class="center order-list-item red">￥{{ goods.goods_actual_price }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="fr ac jc">
        <el-button type="primary" @click="Evaluation">立即评价</el-button>
      </span>
    </re-dialog>
    <!-- 选择商品质量反馈 -->
    <re-dialog :visible.sync="feekdialogVisible" width="900px" title="质量反馈">
      <div class="top">
        <span>{{ feed_list.create_time }}</span>
        <span class="ml20 grey">订单编号：{{ feed_list.order_no }}</span>
        <span class="ml40 blue" v-html="order_state_decide(feed_list)"></span>
      </div>
      <el-table stripe :data="feed_list.orderGoodsBeans">
        <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="goods_standard_name" label="商品型号" align="center"></el-table-column>
        <el-table-column prop="goods_name" label="规格名称" align="center">
          <template slot-scope="scope">
            {{ specNameInit(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="specification_price" label="规格单价" align="center"></el-table-column>
        <el-table-column prop="goods_num" label="商品数量" align="center"></el-table-column>
        <el-table-column prop="goods_actual_price" label="小计总价" align="center"></el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="selectFeedback(scope.row.order_goods_id)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

    </re-dialog>
    <!-- 复购商品选择：确认前先选择本次要复购的订单商品，默认全选。 -->
    <re-dialog :visible.sync="repurchaseDialogVisible" width="900px">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">选择复购商品</p>
        <i class="el-icon-close fz14 cursor" @click="repurchaseDialogVisible = false"></i>
      </div>
      <div v-if="repurchase_order.order_id" class="repurchase-dialog">
        <div class="top">
          <span>{{ repurchase_order.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ repurchase_order.order_no }}</span>
          <span class="ml40 blue" v-html="order_state_decide(repurchase_order)"></span>
        </div>
        <div class="repurchase-business mt20" v-if="showRepurchaseBusinessSelect">
          <span class="fz14 black mr20">商品归属</span>
          <el-radio-group v-model="repurchase_business_id">
            <el-radio label="">益发商品</el-radio>
            <el-radio label="zjky">浙江凯耀商品</el-radio>
          </el-radio-group>
        </div>
        <el-table
            ref="repurchaseTable"
            stripe
            class="mt20"
            :data="repurchaseGoodsList"
            @selection-change="handleRepurchaseGoodsChange"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="商品名称" min-width="220" align="center">
            <template slot-scope="scope">
              <div class="fr ac">
                <!-- <el-image class="repurchase-goods-img fs mr10" :src="scope.row.goods_img" alt/> -->
                <span>{{ scope.row.goods_name }} {{ scope.row.goods_standard_name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格名称" align="center">
            <template slot-scope="scope">
              {{ specNameInit(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="device_id" label="设备信息" align="center">
            <template slot-scope="scope">
              {{ scope.row.device_id ? scope.row.device_id : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="specification_price" label="产品价格" align="center"></el-table-column>
          <el-table-column prop="goods_num" label="数量" align="center"></el-table-column>
          <el-table-column prop="goods_actual_price" label="小计" align="center"></el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="fr ac jc">
        <el-button @click="repurchaseDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmRepurchaseOrder">确认复购</el-button>
      </span>
    </re-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: "",
      order_list: [],
      page: 1,
      total: 0,
      dialogVisible: false,
      feekdialogVisible: false,
      radio: "",
      feekradio: "",
      order_no: "",
      assessment_list: {},
      feed_list: {},
      repurchaseDialogVisible: false,
      repurchase_order: {},
      repurchase_goods_list: [],
      repurchase_business_id: ""
    };
  },
  watch: {
    page(n) {
      if (this.tab != "9999") {
        this.getOrderList();
      } else {
        this.getFeedbackOrders();
      }
    },
    tab(n) {
      this.page = 1;
      if (n != "9999") {
        this.getOrderList();
      } else {
        this.getFeedbackOrders();
      }
    },
  },
  created() {
    let param = this.$route.query;

    if (param.type) {
      this.tab = param.type;
    }

    if (this.tab != "9999") {
      this.getOrderList();
    } else {
      this.getFeedbackOrders();
    }
  },
  computed: {
    repurchaseGoodsList() {
      return this.repurchase_order.orderGoodsBeans || [];
    },
    showRepurchaseBusinessSelect() {
      return this.repurchase_order.contract_template === "yifa";
    }
  },
  methods: {
    goFeed(item) {
      if (item.orderGoodsBeans.length === 1) {
        this.go(
            `/feedback?id=${item.order_id}&goods_id=${item.orderGoodsBeans[0].order_goods_id}`
        );
      } else {
        this.feed_list = item;
        this.feekdialogVisible = true;
      }
    },
    // 反馈商品
    selectFeedback(order_goods_id) {

      this.feekdialogVisible = false;
      this.go(
          `/feedback?id=${this.feed_list.order_id}&goods_id=${order_goods_id}`
      );
      this.feed_list = [];
    },
    // /评价商品
    Evaluation() {
      if (!this.radio) {
        this.$message({
          type: "warning",
          message: "未选择要评价的商品"
        });
        return;
      }
      this.dialogVisible = false;
      this.go(
          `/orderevaluation?id=${this.assessment_list.order_id}&goods_id=${this.radio}`
      );
      this.assessment_list = [];
    },
    // 取消订单
    cancelOrder(id) {
      this.$confirm("是否取消该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
          .then(() => {
            this.post("orderInterfaces/v1.0/cancelOrder", {
              order_id: id
            }).then(res => {
              this.$message({
                type: "success",
                message: "已取消!"
              });
              this.getOrderList();
            });
          })
          .catch(() => {
          });
    },

    getAssessmentGoods(item) {
      if (item.orderGoodsBeans.length == 1) {
        this.go(
            `/orderevaluation?id=${item.order_id}&goods_id=${item.orderGoodsBeans[0].order_goods_id}`
        );
      } else {
        this.assessment_list = item;
        this.dialogVisible = true;
      }
    },
    // 复购
    repurchaseOrder(item) {
      if (!item.orderGoodsBeans || !item.orderGoodsBeans.length) {
        this.$message({
          type: "warning",
          message: "当前订单暂无可复购商品"
        });
        return;
      }
      this.repurchase_order = item;
      this.repurchase_goods_list = this.repurchaseGoodsList.slice();
      this.repurchase_business_id = "";
      this.repurchaseDialogVisible = true;
      this.$nextTick(() => {
        // 打开复购弹窗后默认全选订单商品，用户可自行取消不需要复购的商品。
        if (!this.$refs.repurchaseTable) return;
        this.$refs.repurchaseTable.clearSelection();
        this.repurchaseGoodsList.forEach(goods => {
          this.$refs.repurchaseTable.toggleRowSelection(goods, true);
        });
      });
    },
    handleRepurchaseGoodsChange(list) {
      this.repurchase_goods_list = list;
    },
    confirmRepurchaseOrder() {
      if (!this.repurchase_goods_list.length) {
        this.$message({
          type: "warning",
          message: "请选择要复购的商品"
        });
        return;
      }
      let params = {
        order_id: this.repurchase_order.order_id,
        order_goods_ids: this.repurchase_goods_list.map(el => el.order_goods_id).join(",")
      };
      // 益发订单复购时把商品归属放在同一个弹窗里选择，避免用户再次确认。
      if (this.showRepurchaseBusinessSelect && this.repurchase_business_id) {
        params.business_id = this.repurchase_business_id;
      }
      this.submitRepurchaseOrder(params);
      this.repurchaseDialogVisible = false;
    },
    submitRepurchaseOrder(params) {
      this.post("orderInterfaces/v1.0/repurchaseOrder", params).then(res => {
        this.$message.success("复购成功！")
        setTimeout(() => {
          this.go("/home/shopcart");
        }, 1000);
      });
    },
    //获取订单列表
    getOrderList() {
      let param = {
        page: this.page
      };
      if (this.order_no) {
        this.tab = "";
        param.order_no = this.order_no;
      }
      param.company_check_state = "1";
      param.platform_sale_check_state = "";
      param.contract_check_state = "";
      param.pay_state = "";
      param.send_state = "";
      // 待确定订单
      if (this.tab == "1") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "0,1";
        param.contract_check_state = "0";
        param.pay_state = "";
        param.send_state = "";
        // 全部订单
      } else if (this.tab == "0") {
        param.company_check_state = "";
        param.platform_sale_check_state = "";
        param.pay_state = "";
        param.send_state = "";
        // 待发货
      } else if (this.tab == "4") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "1";
        param.pay_state = "1,2,3";
        param.send_state = "1";
        // 待收货
      } else if (this.tab == "5") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "1";
        param.pay_state = "1,2,3";
        param.send_state = "2,3";
        // 已完成
      } else if (this.tab == "6") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "1";
        param.pay_state = "1,2,3";
        param.send_state = "4";
      } else if (this.tab == "7") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "1";
      } else {
        param.order_state = this.tab;
      }
      this.post("orderInterfaces/v1.0/getOrders", param).then(res => {
        this.order_list = res.data;
        this.total = res.total;
      });
    },
    // 获取反馈订单。
    getFeedbackOrders() {
      this.post("orderInterfaces/v1.0/getFeedbackOrders", {
        page: this.page
      }).then(res => {
        this.order_list = res.data;
        this.total = res.total;
      });
    }
  },
  components: {}
};
</script>

<style lang="scss">
.my-order {
  .order-list-item {
    &:nth-of-type(1) {
      width: 270px;
    }

    &:nth-of-type(2) {
      width: 100px;
    }

    &:nth-of-type(3) {
      width: 130px;
    }

    &:nth-of-type(4) {
      width: 100px;
    }

    &:nth-of-type(5) {
      width: 100px;
    }

    &:nth-of-type(6) {
      width: 100px;
    }
  }

  .order-list {
    .order-item {
      border: 1px solid #e5e5e5;

      .top {
        background-color: #f0f6ff;
        padding: 14px;
      }

      .middle {
        border-bottom: 1px solid #e5e5e5;

        .order {
          .order-left {
            border-right: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;

            &:last-child {
              border-bottom: none;
            }

            .goods_img {
              width: 80px;
              height: 80px;
            }
          }


        }
      }

      .operating {
        width: 100%;
        line-height: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
      }
    }
  }

  .el-dialog {
    .order-left {
      border-right: none !important;
    }

    .radio {
      width: 60px;
      padding-left: 10px;
    }
  }

  .repurchase-dialog {
    .repurchase-business {
      padding: 16px 20px;
      background-color: #f8faff;
      border: 1px solid #e5eefd;
    }

    .repurchase-goods-img {
      width: 60px;
      height: 60px;
      border-radius: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myorder/index.vue